const dataManagementPageMapping: { [key: string]: PageMapping } = {
	"/forecast/data-management/items": {
		actions: [],
		buttons: [],
		icon: "list_alt",
		label: "Items",
		labelKey: "nav.forecast.dataManagement.items.label",
		nav: true,
		title: "Forecast Items",
		titleKey: "nav.forecast.dataManagement.items.title"
	},
	"/forecast/data-management/locations": {
		actions: [],
		buttons: [],
		icon: "location_on",
		label: "Locations",
		labelKey: "nav.forecast.dataManagement.locations.label",
		nav: true,
		title: "Forecast Locations",
		titleKey: "nav.forecast.dataManagement.locations.title"
	},
	"/forecast/data-management/programs": {
		actions: [],
		buttons: [],
		icon: "category",
		label: "Programs",
		labelKey: "nav.forecast.dataManagement.programs.label",
		nav: true,
		title: "Forecast Programs",
		titleKey: "nav.forecast.dataManagement.programs.title"
	}
};

export const featurePageMapping: { [key: string]: PageMapping } = {
	"/forecast": {
		actions: [],
		buttons: [],
		icon: "home",
		label: "FORECAST",
		labelKey: "nav.forecast.module.label",
		nav: false,
		title: ""
	},
	"/forecast/dashboard": {
		actions: [],
		buttons: [],
		icon: "insights",
		label: "Dashboard",
		labelKey: "nav.forecast.dashboard.label",
		nav: true,
		title: "Forecast Dashboard",
		titleKey: "nav.forecast.dashboard.title"
	},
	"/forecast/forecasts": {
		actions: [],
		buttons: [],
		icon: "event_note",
		label: "Forecasts",
		labelKey: "nav.forecast.forecasts.label",
		nav: true,
		title: "Forecasts",
		titleKey: "nav.forecast.forecasts.title"
	},
	"/forecast/forecasting": {
		actions: [],
		buttons: [],
		icon: "table_chart",
		label: "Forecasting",
		labelKey: "nav.forecast.forecasting.label",
		nav: true,
		title: "Forecasting",
		titleKey: "nav.forecast.forecasting.title"
	},
	"/forecast/weekly": {
		actions: [],
		buttons: [],
		icon: "calendar_view_week",
		label: "Weekly",
		labelKey: "nav.forecast.weekly.label",
		nav: true,
		title: "Weekly Forecast",
		titleKey: "nav.forecast.weekly.title"
	},
	"/forecast/parameters": {
		actions: [],
		buttons: [],
		icon: "tune",
		label: "Parameters",
		labelKey: "nav.forecast.parameters.label",
		nav: true,
		title: "Forecast Parameters",
		titleKey: "nav.forecast.parameters.title"
	},
	"/forecast/data-management": {
		actions: [],
		buttons: [],
		children: dataManagementPageMapping,
		icon: "database",
		label: "Data Management",
		labelKey: "nav.forecast.dataManagement.label",
		nav: false,
		title: "Data Management",
		titleKey: "nav.forecast.dataManagement.title"
	},
	"/forecast/settings": {
		actions: [],
		buttons: [],
		icon: "settings",
		label: "Settings",
		labelKey: "nav.forecast.settings.label",
		nav: true,
		title: "Forecast Settings",
		titleKey: "nav.forecast.settings.title"
	}
};

export const flatPageMapping: { [key: string]: PageMapping } = {
	...featurePageMapping,
	...dataManagementPageMapping
};
